import { produce } from "immer";
import {
  resetPayment,
  updatePayment,
  updateBasket,
  updateBasketValid,
  updatePaymentStartAt,
} from "./actions";

const initialPaymentState = {
  basket: {
    validUntil: null,
  },
  isBasketTimeOut: false,
  paymentStartAt: null,
  totalPrice: null,
  product: null,
};

export const paymentSlice = (set, get) => ({
  ...initialPaymentState,
});

export const paymentActions = (set, get) => ({
  [resetPayment]: () => {
    set((state) => ({
      ...state,
      payment: {
        ...initialPaymentState,
      },
    }));
  },
  [updatePayment]: (payload) => {
    set((state) => ({
      ...state,
      payment: {
        ...state.payment,
        ...payload,
      },
    }));
  },
  [updateBasket]: (payload) => {
    set(
      produce((state) => {
        state.payment.basket = {
          ...state.payment.basket,
          ...payload,
        };
      }),
    );
  },
  [updateBasketValid]: (value) => {
    set(
      produce((state) => {
        state.payment.basket.validUntil = value;
      }),
    );
  },
  [updatePaymentStartAt]: (value) => {
    set(
      produce((state) => {
        state.payment.paymentStartAt = value;
      }),
    );
  },
});
